import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a full glass panel wall segment: one big pane, one tile long
// and the full 2.6 m storey height, held by thin matte-black frame strips at
// the top and bottom. Chains with other wall tiles for curtain-wall runs.
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

export const wallGlass = defineModel({
  id: "wall-glass",
  batchId: "modern",
  name: "Glass wall",
  tags: ["modern", "interior", "outdoor", "structure", "wall", "glass", "glazing"],
  summary: "A full-height glass panel wall segment with slim frame strips.",
  description:
    "A one-tile full-glass wall of the Modern Living kit: a single glass " +
    "pane 1 m long and 2.6 m high, held by thin matte-black frame strips " +
    "at floor and ceiling. Chain tiles for curtain-wall runs; rotate in " +
    "90-degree steps to orient.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // bottom frame strip
      { geometry: new THREE.BoxGeometry(1.0, 0.08, 0.1), color: BLACK, position: [0, 0.04, 0] },
      // top frame strip
      { geometry: new THREE.BoxGeometry(1.0, 0.08, 0.1), color: BLACK, position: [0, 2.56, 0] },
      // the glass pane spanning between the strips
      { geometry: new THREE.BoxGeometry(1.0, 2.44, 0.05), color: GLASS, position: [0, 1.3, 0] },
    ];
  },
  animations: [],
});
